export default {
  labels: {
    dont_have_account: 'Noch kein Konto? ',
  },
  title: 'Anmelden',
  buttons: {
    sign_up: 'Registrieren',
  },
};
